import { ServiceRequestModal } from '../../../../components/ServiceResquests/Modal'
import { i18n } from '../../../../translate/i18n'
import { TypeDinamicGrid } from '../dinamyc-pages.types'


type Props = {
    addGrid: (type: TypeDinamicGrid) => void
    opened: boolean
    onClose: () => void
}


export const GridOverlay = ({ addGrid, opened, onClose }: Props) => {
    const optionsGrid = [
        { type: TypeDinamicGrid.image, label: i18n.t('agregador_dinamic_page.grid.image') },
        { type: TypeDinamicGrid.carousel, label: i18n.t('agregador_dinamic_page.grid.carousel') },
        { type: TypeDinamicGrid.text, label: i18n.t('agregador_dinamic_page.grid.text') },
        { type: TypeDinamicGrid.content, label: i18n.t('agregador_dinamic_page.grid.content') },
        { type: TypeDinamicGrid.hero, label: i18n.t('agregador_dinamic_page.grid.hero') },
    ]

    if (!opened) return null

    return (
        <ServiceRequestModal
            onCloseAction={onClose}
            title={'Adicionar Grid'}
            showAlert={false}
        >
            <div className='pt-6 d-grid gap-2'>
                {optionsGrid.map((meta) => (
                    <button
                        key={meta.type}
                        className='btn btn-sm btn-light d-flex align-items-center text-start'
                        onClick={() => {
                            addGrid(meta.type)
                            onClose()
                        }}
                    >
                        {meta.label}
                    </button>
                ))}
            </div>
        </ServiceRequestModal>
    )
}